import React, { useState } from "react";
import "./OrderPicker.scss"
import deliveryIc from "../../assets/delivery.svg"
import takawayIc from "../../assets/takeaway.svg"
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { useDispatch } from "react-redux";
import { setSelectedOrderType } from "../../../../../../../redux/resturantWidgetSlice";

const OrderPicker = () => {
    const dispatch = useDispatch()
    const defaultOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).defaultOrderType

    const [selectedType, setSelectedType] = useState(defaultOrderType)
    const orderTypes = [
        { name: "Collection", type: "collection", icon: takawayIc },
        { name: "Delivery", type: "delivery", icon: deliveryIc },
    ]
    const handleType = () => {
        dispatch(setSelectedOrderType(selectedType))
    }
    return (
        <div className="Voucher-OrderPicker">
            <div className="header-text">Choose Your Order Type</div>
            <div className="sub-text">Select an option that best suits your preferences.</div>
            <div className="order-type-containers">
                {orderTypes.map((orderType, index) => {
                    return (<div key={index} className="order-type-container" onClick={() => {
                        setSelectedType(orderType.type)
                    }} >
                        <div className="order-type-container-left">
                            {selectedType === orderType.type ? <div className="radio-type-selected"><div className="radio-type-selected-inner" /></div> : <div className="radio-type" />}{orderType.name}</div>
                        <div className="order-type-container-right"><img alt="" src={orderType.icon} /></div>

                    </div>)
                })}
            </div>
            <div className="proceed-btn" onClick={handleType}>Proceed</div>

        </div>
    )
}
export default OrderPicker